<template lang="pug">
  div
    .l-content
      .l-container
        .c-container
          .c-container__image.u-text-center
            img.small-icon(
            src="@/assets/img/signup/registration-completed-icon.png"
            )
          .c-container__title.u-ptm.u-text-center
            p プロフィール登録が完了しました
            p 仮会員審査を行います
          .c-container__annotation
            div
              span ギグベースへご登録ありがとうございます。
              br
              span 入力いただきました情報を元に仮会員審査を行います。
              br
              span 1~2営業日後に審査結果をご連絡します。
            br
            p
              | 3営業日以上経っても結果が届かない場合は、お手数ですが、
              a.u-text-underline(href="mailto:talent-support@gigbase.jp") タレントサポート
              | までご連絡ください。
          .c-container__annotation
            div.u-text-center.steps-heading < 今後の流れ >
            br
            div.step
              span.step-circle 1
              span.step-name アカウント登録審査結果を通知
              span.step-mute （1~2営業日）
            div.step
              span.step-circle 2
              span.step-name ログイン
              span.step-mute （お仕事の閲覧が可能）
            div.step
              span.step-circle 3
              span.step-name ご本人確認書類の提出
            div.step
              span.step-circle 4
              span.step-name 本人確認完了
              span.step-mute （全ての機能がご利用可能）
</template>

<script lang="babel">
import LogoutMixin from "@/mixins/LogoutMixin";
import nativeMethodDispatcher from "@/utils/nativeMethodDispatcher";

export default {
  name: 'RegistrationCompleted',
  mixins: [ LogoutMixin ],
  mounted() {
    this.$emit('page-navbar', false)
    nativeMethodDispatcher.dispatch('sendCompletedSignupProfile');
  }
}
</script>

<style lang="scss" scoped>
  .l-content {
    height: 100%;
  }
  .c-container {
    overflow: hidden;
    padding: {
      top: 100px;
    }
    &__title {
      font-size: 20px;
      line-height: 36px;
      text-align: center;
      margin-bottom: 40px;
    }
    &__annotation {
      font-size: 14px;
      line-height: 24px;
      letter-spacing: 0.03em;
      &.u-mtm {
        margin-top: 36px;
      }
      .c-label {
        margin-left: 0px;
      }
      margin-bottom: 40px;
    }
  }
  .l-container.is-bottom {
    .c-button-float-lg {
      position: fixed;
      bottom: 24px;
      right: 16px;
      color: white;
      background-color: #F94848;
      box-shadow: 0px 5px 12px rgba(111, 0, 24, 0.2);
      .material-icons {
        vertical-align: initial;
      }
    }
    .c-button-floating-action-group {
      button:disabled {
        background: #E0E0E0;
      }
    }
  }
  .small-icon {
    width: 20%;
    margin-bottom: 10px;
  }
  .steps-heading {
    color: #F94848;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 14px;
  }
  .step {
    margin-bottom: 10px;
  }
  .step-circle {
    width: 22px;
    height: 22px;
    background: #F94848;
    border-radius: 30px;

    font-size: 14px;
    line-height: 22px;
    color: #FFFFFF;
    display: inline-block;
    text-align: center;
    margin-right: 5px;
  }
  .step-name {
    font-size: 14px;
    line-height: 14px;
    color: #1D1918;
  }
  .step-mute {
    font-size: 11px;
    color: #909090;
  }
  .logout {
    font-size: 14px;
    line-height: 14px;
    letter-spacing: 0.03em;
    color: #A6A5A5;
  }
</style>
